import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Card, CardBody, Button, InputGroup, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Paper";

import Avatar from "../../Avatar";
import { columnsUser } from "./AllowedUserList";
import { getDataCreated } from "../../../hooks/useLocaleDate";
import { addUserMasterContract } from "../../../store/actions/admin";

const MasterContractDetails = ({ id }) => {
	const { masterContracts, users } = useSelector((state) => state.admin);
	const [addedUser, setAddedUser] = useState("");
	const dispatch = useDispatch();

	const selectedContract = () => {
		return masterContracts.find((contract) => contract._id === id);
	};

	const renderUserImg = () => {
		if (selectedContract !== null && selectedContract().image) {
			return (
				<img
					height="110"
					width="110"
					alt="contract avatar"
					src={
						selectedContract().image.includes("https://")
							? selectedContract().image
							: `${process.env.REACT_APP_IPFS_HOST}/${
									selectedContract()?.customImage ?? selectedContract().image
							  }`
					}
					className="img-fluid rounded mt-3 mb-2"
				/>
			);
		} else {
			const stateNum = Math.floor(Math.random() * 6),
				states = [
					"light-success",
					"light-danger",
					"light-warning",
					"light-info",
					"light-primary",
					"light-secondary",
				],
				color = states[stateNum];
			return (
				<Avatar
					initials
					color={color}
					className="rounded mt-3 mb-2"
					content={selectedContract()?.customName ?? selectedContract().name}
					contentStyles={{
						borderRadius: 6,
						fontSize: "calc(48px)",
						width: "100%",
						height: "100%",
					}}
					style={{
						height: "110px",
						width: "110px",
					}}
				/>
			);
		}
	};

	if (!selectedContract) {
		return <h1>Loading</h1>;
	}

	const dataToRenderUsers = () => {
		const allowedUserList = users.filter((user) =>
			selectedContract().allowedUser.includes(user._id)
		);
		if (!allowedUserList) {
			return [];
		} else {
			return allowedUserList;
		}
	};
	const renderOptions = () => {
		return users.map((user) => (
			<option
				key={user._id}
				value={user._id}
				disabled={selectedContract().allowedUser.includes(user._id)}
				label={`
                ${user.account} 
                // 
                ${user.email} 
                `}
			/>
		));
	};
	const handleUserSelect = (e) => {
		setAddedUser(e.target.value);
	};
	const addUser = (e) => {
		dispatch(addUserMasterContract(id, addedUser));
		setAddedUser("");
	};

	return (
		<>
			<Card className="mb-3 px-3 pb-3">
				<CardBody className="d-flex justify-content-between">
					<div className="user-avatar-section col-3">
						<div className="d-flex align-items-center flex-column">
							{renderUserImg()}
						</div>
					</div>
					<div className="info-container col-9">
						<h4 className="fw-bolder border-bottom pb-50 mb-1">Details</h4>
						<table className="mt-2 mt-xl-0 w-100">
							<tbody>
								<tr>
									<th>Name</th>
									<td>
										{selectedContract()?.customName ?? selectedContract().name}
									</td>
								</tr>
								<tr>
									<th>Version</th>
									<td>{selectedContract().version || "No info"}</td>
								</tr>
								<tr>
									<th>Type</th>
									<td>{selectedContract().type || "No info"}</td>
								</tr>
								<tr>
									<th>Address</th>
									<td>{selectedContract().address}</td>
								</tr>
								<tr>
									<th>Date create</th>
									<td>{getDataCreated(selectedContract().dataCreate, true)}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</CardBody>
				<Typography component="h2" sx={{ width: "100%", textAlign: "center" }}>
					Allowed users for contracts:
				</Typography>
				<InputGroup className="my-3">
					<Input
						type="select"
						name="selectedContract"
						value={addedUser}
						id="contractSelect"
						className="w-50"
						onChange={handleUserSelect}
					>
						<option value="" disabled>
							Select user
						</option>
						{renderOptions()}
					</Input>
					<Button
						outline
						disabled={!addedUser}
						className="px-2.5 mx-2 mb-1"
						color="primary"
						onClick={(e) => addUser(e)}
					>
						Add
					</Button>
					<Button
						outline
						disabled={!addedUser}
						className="px-2.5 mx-2 mb-1"
						color="primary"
						onClick={() => setAddedUser("")}
					>
						Clear
					</Button>
				</InputGroup>
				<Paper>
					{selectedContract().allowedUser.length > 0 ? (
						<Card className="overflow-hidden">
							<div className="react-dataTable">
								<DataTable
									noHeader
									responsive
									columns={columnsUser}
									sortIcon={<ChevronDown />}
									highlightOnHover
									pointerOnHover
									className="react-dataTable"
									data={dataToRenderUsers()}
								/>
							</div>
						</Card>
					) : (
						<Box sx={{ width: "100%", textAlign: "center" }}>
							Not available data
						</Box>
					)}
				</Paper>
			</Card>
		</>
	);
};

export default MasterContractDetails;
